import { Button, ButtonLabel } from "@similarweb/ui-components";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { translate } from "app/filters/i18nFilter";

import { ButtonsContainer, MODAL_CUSTOM_STYLES, ModalSubtitle, ModalTitle } from "./styles";

type Props = {
    isOpen: boolean;
    isLoading?: boolean;
    title: string;
    subtitle: string;
    onCancel: VoidFunction;
    onConfirm: VoidFunction;
};

const EmailUnsubscribeModal = (props: Props) => {
    const { isOpen, isLoading = false, title, subtitle, onConfirm, onCancel } = props;

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            customStyles={MODAL_CUSTOM_STYLES}
        >
            <ModalTitle data-automation="email-unsubscribe-modal.title">{title}</ModalTitle>
            <ModalSubtitle data-automation="email-unsubscribe-modal.subtitle">{subtitle}</ModalSubtitle>

            <ButtonsContainer>
                <Button
                    type="flat"
                    dataAutomation="email-unsubscribe-modal.cancel-button"
                    onClick={onCancel}
                >
                    <ButtonLabel>{translate("si.common.button.cancel")}</ButtonLabel>
                </Button>
                <Button
                    isLoading={isLoading}
                    type="primary"
                    dataAutomation="email-unsubscribe-modal.confirm-button"
                    onClick={onConfirm}
                >
                    <ButtonLabel>{translate("si.common.button.confirm")}</ButtonLabel>
                </Button>
            </ButtonsContainer>
        </ProModal>
    );
};

export default EmailUnsubscribeModal;
